<script setup lang="ts">
import type { SlugBodyItem } from '~/components/slug/body';

useSeoMeta({
  title: 'Multifunkční sál | Okgym - Fitcentrum | Pardubický Kraj',
  description:
    'Fitness, Gym, Solarium, Box - Lepší nabídku nenajdeš! Pro studenty zvýhodněná nabídka jen v Okgym',
});

const services: SlugBodyItem[] = [
  {
    title: 'Bungee Workout',
    description:
      'Bungee workout je dynamická forma cvičení, při které je cvičenec připojen k elastickému lanu zavěšenému ke stropu. Cvičení kombinuje prvky akrobacie, tance a silového tréninku v jednom – a hlavně je to neskutečná zábava. Výborně posiluje celé tělo, zejména střed (jádro), nohy a hýždě, a zároveň šetří klouby díky sníženému dopadu. Po lekci odcházíte nejen fyzicky unavení, ale i s jasnou hlavou a dobrou náladou.',
    image: {
      url: '/images/sal/bungee.webp',
      alt: 'Bungee Workout',
    },
  },
  {
    title: 'Pilates',
    description:
      'Pilates je systém cvičení zaměřený na vědomou práci s tělem, hlubokou stabilizaci a správné dýchání. Na lekcích se pracuje s vlastní vahou těla nebo s pomůckami, jako je overball, lehké činky nebo theraband. Zásadně zlepšuje držení těla, posiluje hluboké svaly páteře a napomáhá rehabilitaci po zraněních. Je to zároveň skvělý nástroj pro snížení stresu a celkové zklidnění nervové soustavy.',
    image: {
      url: '/images/sal/pilates.webp',
      alt: 'Lekce Pilates',
    },
  },
  {
    title: 'Klasická jóga',
    description:
      'Klasická jóga vychází z tisícileté tradice a propojuje fyzické cvičení, práci s dechem a meditaci v jeden celistvý systém. Pravidelná praxe jógy zvyšuje flexibilitu, sílu i celkovou tělesnou kondici. Zároveň prokazatelně snižuje hladinu kortizolu (stresového hormonu) a napomáhá lepšímu spánku. Jóga vás učí naslouchat svému tělu a přinášet klid i do každodenního života.',
    image: {
      url: '/images/sal/yoga.webp',
      alt: 'Klasická jóga',
    },
  },
  {
    title: 'H.E.A.T.',
    description:
      'Intenzivní intervalový trénink kombinující prvky aerobiku, funkčního tréninku a silových cvičení. Lekce plná energie, pohybu a motivace probíhá na hudbu ve skupinové atmosféře. H.E.A.T. efektivně spaluje kalorie, zvyšuje kardiovaskulární kondici a zlepšuje celkovou výdrž. Díky afterburn efektu tělo spaluje energii ještě několik hodin po skončení lekce.',
    image: {
      url: '/images/sal/vsude.webp',
      alt: 'H.E.A.T. trénink',
    },
  },
];

const text = {
  title: 'Naše lekce – pohyb, který vám sedí.',
  subtitle: 'MULTIFUNKČNÍ SÁL',
  description:
    'Ať už hledáte dynamický trénink pro spalování kalorií, nebo klidnější cvičení pro zpevnění těla a vyčištění mysli, v našem multifunkčním sále si vyberete. Lekce jsou vhodné pro všechny věkové kategorie bez ohledu na předchozí zkušenosti.',
} as const;
</script>

<template>
  <PageContainer no-alignment no-padding>
    <SlugHeader
      :title="text.title"
      :subtitle="text.subtitle"
      :description="text.description"
      icon="icon:multihall"
      :image-header="{
        url: '/images/sal/header.webp',
        alt: 'Lezecká stěna',
      }"
      :links="[
        {
          to: '/cenik-mf-sal.pdf',
          label: 'Ceník',
          icon: 'icon:document',
        },
        {
          to: '/rozvrh-mf-sal-1790090226410.pdf',
          label: 'Rozvrh',
          icon: 'icon:document',
        },
      ]"
    />
    <SlugBody :items="services" />
    <Feed />
    <IndexGallery />
  </PageContainer>
</template>
